
// The normal export * from syntax is breaking the unit tests for some reason. Maybe a different
// babel config?
// TODO: fix it.

import {
    mix,
} from './mix';

import {
    isInitialized,
    isInitializing,
    initialize,
    requiresPolyfill,
    createApplication,
} from './lifecycle';

import {
    useComponent,
    useComponents,
    useInteraction,
    useInteractions,
} from './features';

import * as utils from './utils';
import * as environment from './environment';
import * as core from '../core';
import * as mixins from '../mixins';
import * as errors from '../errors';
import * as manifest from './manifest';
import * as storeConstants from './store.constants';
import * as interactions from '../interactions/interactions';

const result = {
    mix,
    isInitialized,
    isInitializing,
    initialize,
    useComponent,
    useComponents,
    useInteraction,
    useInteractions,
    requiresPolyfill,
    createApplication,

    utils,
    core,
    manifest,
    mixins,
    errors,
    environment,
    storeConstants,
    interactions,

    /**
     * Gets the version number of the framework. This number follows the semantic versioning
     * standards.
     * @see http://semver.org/spec/v2.0.0.html
     */
    version: {
        major: 1,
        minor: 0,
        patch: 0,
    },
};

result.version.string = `v${result.version.major}.${result.version.minor}.${result.version.patch}`;

Object.freeze(result);
Object.freeze(result.utils);
Object.freeze(result.core);
Object.freeze(result.manifest);
Object.freeze(result.interactions);
Object.freeze(result.mixins);
Object.freeze(result.version);

export default result;


// WEBPACK FOOTER //
// ./source/framework/instance/index.js